import axios from "axios";
import { config } from "@/config/constants.js";

export default {
  namespaced: true,
  state: {
    list: [],
    selected:null,
    page: 1,
    total: 0,
    options: {
      itemsPerPage: 10,
      search: ""
    }
  },
  mutations: {
    request(state) {
      state.status = "loading";
    },
    success(state, data) {
      state.status = "success";
      if (data && data["list"]) {
        state.list = data["list"];
      }
      if (data && data["total"]) {
        state.total = data["total"];
      }
    },
    error(state) {
      state.status = "error";
    },
    options(state, data) {
      state.options = data;
    }
  },
  actions: {
    getNews({ commit, state }, options) {
      return new Promise((resolve, reject) => {
        commit("request");
        axios
          .get(config.api_url + "news", {
            params: options
          })
          .then(response => {
            commit("success", {
              list: response.data,
              total: parseInt(response.headers["pagination-count"])
            });
            resolve(response.data);
          })
          .catch(err => {
            commit("error");
            reject(err);
          });
      });
    }
  },
  getters: {
    status(state) {
      return state.status;
    }
  }
};
